<template>
  <div class="description-box">
    <div class="img-box" v-if="imgUrl">
      <img class="img-bg" src="https://cdngarenanow-a.akamaihd.net/webmain/static/game_service/bind/img_gift_bg.png" />
      <img class="img" :src="imgUrl" />
    </div>
    <div class="text" v-text="text"></div>
  </div>
</template>

<script>
export default {
  name: 'GSDescription',
  props: {
    imgUrl: {
      type: String,
      required: false
    },
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/vars/base';

.description-box {
  min-height: $base-size * 118;
}

.img-box {
  position: relative;
  float: left;
  width: $base-size * 298;
  height: $base-size * 118;
  overflow: visible;
  margin-right: $base-size * 40;

  .img-bg {
    position: absolute;
    width: $base-size * 500;
    left: $base-size * (-104);
    top: $base-size * (-104);
  }

  .img {
    position: absolute;
    height: 100%;
    max-width: $base-size * 290;
    left: 50%;
    transform: translate(-50%, 0);
    -ms-transform: translate(-50%, 0);
  }
}

.text {
  display: table-cell;
  color: #E0C390;
  font-size: $font-size;
  letter-spacing: 0;
  line-height: $base-size * 56;
}
</style>



// WEBPACK FOOTER //
// src/components/GSDescription.vue